<template>
  <section class="all_emp card_style">
    <div class="main_header_style">
      <h4>{{ $t("The views") }}</h4>
    </div>

    <div class="row options mb-5">
      <form class="col-6">
        <i class="fa-solid fa-magnifying-glass"></i>
        <input type="text" class="search form-control" :placeholder="$t('search by name')" />
      </form>

      <div class="col-6 d-flex justify-content-end">
        <button
          class="PrimaryButton btn w-50"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#offcanvasBottom"
          aria-controls="offcanvasBottom"
        >
          <i class="fa-solid fa-plus"></i> {{ $t("New View") }}
        </button>
      </div>
      <addView @fetch-data="reloadData" />
    </div>

    <div class="row">
      <table class="table" id="ViewTable">
        <thead>
          <tr>
            <th>ID</th>
            <th>{{ $t("title") }}</th>
            <th>{{ $t("Control") }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(view, index) in views.data" :key="index">
            <td>{{ view.id }}</td>
            <td>{{ view.title }}</td>
            <td>
              <router-link
                :to="`/view/edit/${view.id}`"
                class="btn btn-success text-white"
              >
                <i class="fa-regular fa-pen-to-square"></i>
              </router-link>

              <button
                class="btn btn-danger text-white mx-1"
                @click="deleteView(view.id, index)"
              >
                <i class="fa-solid fa-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="row">
      <pagination
        :data="views"
        class="mx-auto d-flex align-items-center justify-content-center pagination"
        @pagination-change-page="fetchAllViews"
      >
        <template v-slot:prev-nav>&lt;</template>
        <template v-slot:next-nav>&gt;</template>
      </pagination>
    </div>
  </section>
</template>

<script>
import axios from "axios";
import pagination from "laravel-vue-pagination";
import Swal from "sweetalert2";
import addView from "@/components/room/view/addView.vue";

export default {
  name: "allViews",
  data() {
    return {
      views: [],
    };
  },
  components: {
    pagination,
    addView,
  },
  methods: {
    fetchAllViews(page = 1) {
      axios
        .post(`/fetch_all_view?page=${page}`, { count: 10 })
        .then(({ data }) => {
          this.views = data.data;
        });
    },
    deleteView(viewId, index) {
      Swal.fire({
        title: this.$t("check_delete"),
        text: this.$t("are_you_sure_delete"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: this.$t("back"),
        confirmButtonText: this.$t("confirm_delete"),
      }).then((result) => {
        if (result.isConfirmed) {
          const fromClick = true;
          axios
            .delete(`/view_types/${viewId}`, { fromClick })
            .then(({ data }) => {
              if (data.status == true) {
                Swal.fire("", data.message, "success");
                this.views.data.splice(index, 1);
              } else {
                Swal.fire("", data.message, "error");
              }
            })
            .catch((error) => {
              if(error.response.status != 403){
                Swal.fire("", error.message, "error");
              }
            });
        }
      });
    },
    reloadData() {
      this.fetchAllViews();
    },
  },
  mounted() {
    this.fetchAllViews();
  },
  created() {
    localStorage.removeItem("flightData");
    localStorage.removeItem("flightTrips");
    localStorage.removeItem("bookDataFlight");
    localStorage.removeItem("bookDetails");
    localStorage.removeItem("hotelData");
    localStorage.removeItem("bookData");
  },
};
</script>

<style lang="scss" scoped>
@import "../_room";
</style>
